var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterMyPageOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Selected=False, Name=My"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 6C44.2843 6 51 12.7157 51 21C51 25.1108 49.3464 28.8353 46.6681 31.5448C48.1304 31.946 49.5774 32.4309 51 33L53.4656 33.9862C61.0359 37.0144 66 44.3465 66 52.5C66 59.9558 59.9558 66 52.5 66H19.5C12.0442 66 6 59.9558 6 52.5C6 44.3465 10.9641 37.0144 18.5344 33.9862L21 33C22.4226 32.4309 23.8696 31.946 25.3336 31.5451C22.6536 28.8353 21 25.1108 21 21C21 12.7157 27.7157 6 36 6ZM24.258 38.178L23.2283 38.5709L20.7628 39.5571C15.4704 41.6741 12 46.7999 12 52.5C12 56.4764 15.0946 59.7301 19.0069 59.984L19.5 60H52.5C56.6421 60 60 56.6421 60 52.5C60 47.0191 56.7915 42.0692 51.8397 39.8146L51.2372 39.5571L48.7717 38.5709C40.9146 35.428 32.1875 35.2971 24.258 38.178ZM27 21C27 16.0294 31.0294 12 36 12C40.9706 12 45 16.0294 45 21C45 25.9706 40.9706 30 36 30C31.0294 30 27 25.9706 27 21Z",
    fill: "#9B9DA0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterMyPageOff);
export default __webpack_public_path__ + "static/media/footer-my-page-off.6250566cd76508e289084ad4a19bbcd3.svg";
export { ForwardRef as ReactComponent };